import React from 'react';
import cn from 'classnames';

import IMAGE_ENABLE_DAC from 'assets/images/modals/enable_dac.png';
import IMAGE_REJECT_DAC from 'assets/images/modals/reject_dac.png';
import Button from 'components/form/Button.component';
import CurrencySign from 'components/price/CurrencySign.component';
import SmsPrice from 'components/price/SmsPrice.component';
import { useTheme } from 'providers/Theme.provider';
import createNodeKey from 'utils/react/createNodeKey.util';
import C from 'utils/values/constant.util';

import CN from './DacModalContent.module.scss';

const DATA_BENEFITS = C([
  'Sent automatically at time of booking',
  'Clients can add straight to phone calendar',
  `No more missed appointments!`,
]);

const DATA_LOSES = C([
  'Time spent writing out by hand',
  'Risk of clients missing appointments',
  'Can be easily lost',
  `Not eco-friendly`,
]);

const DacModalContent = ({ selectNo, selectYes, handleSelection, onRejectDac, onEnableDac }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="DacModalContent"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.flex}>
        <div
          className={cn({
            [CN.card]: true,
            [CN.active]: selectYes,
          })}
          role="button"
          onClick={handleSelection}
          tabIndex={0}
        >
          <div className={CN.imageCard}>
            <img src={IMAGE_ENABLE_DAC} className={CN.image} alt="confirmation SMS illustration" />
          </div>
          <div className={CN.content}>
            <div className={CN.cardTitle}>Digital Appointment Cards</div>

            {DATA_BENEFITS.map((text, index) => (
              <div className={CN.item} key={createNodeKey({ index, text })}>
                {text}
              </div>
            ))}
            <div className={CN.item}>
              <CurrencySign />
              <SmsPrice /> per booking column +VAT
            </div>
            <div className={CN.buttonContainer}>
              <Button variant="primaryForce" onClick={onEnableDac}>
                <div className={CN.buttonGap}>ENABLE & ADD TO BILL</div>
              </Button>
            </div>
          </div>
        </div>
        <div
          className={cn({
            [CN.card]: true,
            [CN.active]: selectNo,
          })}
          role="button"
          onClick={handleSelection}
          tabIndex={0}
        >
          <div className={CN.imageCard}>
            <img src={IMAGE_REJECT_DAC} className={CN.image} alt="Paper Cards illustration" />
          </div>
          <div className={CN.content}>
            <div className={CN.cardTitle}>Paper Cards</div>
            {DATA_LOSES.map((text, index) => (
              <div className={CN.item} key={createNodeKey({ index, text })}>
                {text}
              </div>
            ))}
            <div className={CN.buttonContainer}>
              <Button variant="outline" onClick={onRejectDac}>
                <div className={CN.buttonGap}>STAY WITH PAPER CARDS</div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DacModalContent;
